import { useTheme } from 'styled-components';

import { MessageOptions, MessageType } from '@dreryk/react-components';

export const useVideoConsultationWarningMessageOptions = (): MessageOptions<{
   [MessageType.WARNING]: MessageType;
}> => {
   const theme = useTheme();

   return {
      [MessageType.WARNING]: {
         color: theme.warning,
         backgroundColor: theme.warningLighter,
         labelColor: theme.warningDarker,
      },
   };
};
